module.exports = __webpack_public_path__ + "img/header-b.900f958.jpg";